export default __webpack_public_path__ + "static/media/bgMobilePink.d25f89f6.svg";